import React, { useState, useCallback, useEffect } from "react";
import { render } from "react-dom";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photos } from "./photos";
import './styles.css';

function App() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [displayedPhotos, setDisplayedPhotos] = useState([]);
  const imagesPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  // Function to load more images when reaching the bottom of the page
  const loadMoreImages = useCallback(() => {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      // Calculate the index range for the new images to be displayed
      // Increase the current page number
      const startIndex = currentPage * imagesPerPage;
      const endIndex = startIndex + imagesPerPage;

      // Add the next 10 photos to the displayedPhotos state
      setDisplayedPhotos((prevPhotos) => [...prevPhotos, ...photos.slice(startIndex, endIndex)]);
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }, [currentPage]);

  // Attach the loadMoreImages function to the scroll event
  useEffect(() => {
    window.addEventListener("scroll", loadMoreImages);
    return () => {
      window.removeEventListener("scroll", loadMoreImages);
    };
  }, [loadMoreImages]);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  // Initially display the first 10 photos
  useEffect(() => {
    const startIndex = 0;
    const endIndex = startIndex + imagesPerPage;
    setDisplayedPhotos(photos.slice(startIndex, endIndex));
  }, []);

  return (
    <div className="indexpage">
      <header>
        <h1>Photos</h1>
      </header>
      <div style={{ paddingLeft: 20, paddingRight: 20 }}>
        <Gallery margin={20} photos={displayedPhotos} onClick={openLightbox} />
        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={photos.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
      <div style={{ textAlign: "center" }}>
        {
          displayedPhotos.length == photos.length ? <div></div> :

            <div><br />
              <button onClick={() => {
                const startIndex = currentPage * imagesPerPage;
                const endIndex = startIndex + imagesPerPage;
                // Add the next 10 photos to the displayedPhotos state
                setDisplayedPhotos((prevPhotos) => [...prevPhotos, ...photos.slice(startIndex, endIndex)]);
                setCurrentPage((prevPage) => prevPage + 1);
              }}>
                Load More
              </button>
            </div>
        }
      </div>
      <footer>
        <p>Feel free to reach out to me if you're interested in obtaining the uncompressed photo: zhenyuan@zhenyuan.cool</p>
        <p>© 2023 zhenyuan.cool. All rights reserved.</p>
      </footer>
    </div>
  );
}


render(<App />, document.getElementById("app"));



// WEBPACK FOOTER //
// ./src/index.js